import React from 'react';
import { TextInput } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ColorNameEditor(opts) {
  const {
    value: colorName
  } = opts;
  return /*#__PURE__*/_jsx(TextInput, {
    disabled: true,
    value: colorName
  });
}